<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-6 px-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Reporte de Ventas</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#4318FF" class="mr-2">mdi-chart-line</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Total del periodo: <span class="indigo--text">S/ {{ totalRecaudado }}</span>
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end">
        <periodo-busqueda @buscar="onBuscar"/>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4">
      <v-data-table :headers="headers" :items="ventas" :loading="cargando" class="elevation-0">
        <template v-slot:[`item.codigo_ticket`]="{ item }">
          <code class="font-weight-bold grey--text text--darken-3 px-2 py-1 rounded">#{{ item.codigo_ticket }}</code>
        </template>
        
        <template v-slot:[`item.total`]="{ item }">
          <span class="font-weight-black green--text text--darken-2">S/ {{ item.total }}</span>
        </template>

        <template v-slot:[`item.acciones`]="{ item }">
          <v-btn icon class="action-primary" @click="verDetalle(item)">
            <v-icon small>mdi-eye-outline</v-icon>
          </v-btn>
          <v-btn icon class="action-danger" @click="confirmarAnularVenta(item)" v-if="!item.anulado">
            <v-icon small>mdi-cancel</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoDetalle" max-width="500px">
      <v-card class="rounded-xl pa-6">
        <v-card-title class="font-weight-black justify-space-between" style="color: #1B2559;">
          Ticket: #{{ ticketSeleccionado }}
          <v-icon color="#4318FF">mdi-receipt-text-outline</v-icon>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-list dense class="pa-0">
          <v-list-item v-for="(prod, i) in detalleVenta" :key="i" class="px-0">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ prod.nombre }}</v-list-item-title>
              <v-list-item-subtitle>{{ prod.cantidad }} unid. x S/ {{ prod.precio }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="font-weight-black text-right" style="color: #1B2559;">
              S/ {{ prod.subtotal }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-divider class="my-4"></v-divider>
        <v-card-actions class="justify-center">
          <v-btn color="#4318FF" dark class="rounded-lg px-8 text-none font-weight-bold" @click="dialogoDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrarAnularVenta" max-width="520">
      <dialogo-confirm-admin @confirmar="onConfirmAdminVenta" @cancelar="mostrarAnularVenta = false" />
    </v-dialog>
  </div>
</template>

<script>
import HttpService from '../Servicios/HttpService'
import PeriodoBusqueda from './Dialogos/PeriodoBusqueda.vue'
import DialogoConfirmAdmin from './Dialogos/DialogoConfirmAdmin.vue'

export default {
  components: { PeriodoBusqueda, DialogoConfirmAdmin },
  data: () => ({
    cargando: false, dialogoDetalle: false, mostrarAnularVenta: false,
    ventas: [], totalRecaudado: 0, detalleVenta: [],
    ticketSeleccionado: '', ventaSeleccionada: null, motivoAnularVenta: '',
    filtros: { fechaInicio: null, fechaFin: null },
    headers: [
      { text: 'Ticket', value: 'codigo_ticket' },
      { text: 'Fecha / Hora', value: 'fecha' },
      { text: 'Atendido por', value: 'cajero' },
      { text: 'Total Venta', value: 'total' },
      { text: 'Ver Detalle', value: 'acciones', sortable: false, align: 'center' }
    ]
  }),
  mounted() { this.obtenerDatos(); },
  methods: {
    onBuscar(fechas) {
      this.filtros = { fechaInicio: fechas[0], fechaFin: fechas[1] };
      this.obtenerDatos();
    },
    async obtenerDatos() {
      this.cargando = true;
      const res = await HttpService.obtenerConDatos({ metodo: 'obtenerVentas', filtros: this.filtros }, 'reportes.php');
      this.ventas = res.ventas || [];
      this.totalRecaudado = res.totalRecaudado || 0;
      this.cargando = false;
    },
    async verDetalle(item) {
      this.ticketSeleccionado = item.codigo_ticket;
      this.detalleVenta = await HttpService.obtenerConDatos({ metodo: 'obtenerDetalle', idVenta: item.id }, 'reportes.php');
      this.dialogoDetalle = true;
    },
    confirmarAnularVenta(item) {
      this.ventaSeleccionada = item;
      this.mostrarAnularVenta = true;
    },
    async onConfirmAdminVenta(creds) {
      this.cargando = true;
      try {
        const ver = await HttpService.obtenerConDatos({ metodo: "verificar_admin", usuario: creds.usuario, password: creds.password }, "usuarios.php");
        if (ver && ver.resultado) {
          const res = await HttpService.obtenerConDatos({ metodo: "anular", id: this.ventaSeleccionada.id, usuario: ver.id, motivo: creds.motivo }, "ventas.php");
          if (res && (res.resultado === true || res.resultado)) {
            this.mostrarAnularVenta = false;
            this.obtenerDatos();
            alert(res.mensaje || "Venta anulada");
          } else {
            alert(res.mensaje || "No se pudo anular");
          }
        } else {
          alert("Credenciales inválidas");
        }
      } catch(e) {
        console.error(e);
        alert("Error de conexión");
      } finally { this.cargando = false; }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ReporteVentas.vue